import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { MaterialModel } from '../../../models/dictionaries/material.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;


@Component({
  selector: 'app-materials-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addMaterialModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="materialForm">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedMaterial.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedMaterial.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">R Stab Name:</span>
                                    <input type="text" [(ngModel)]="editedMaterial.rStabName" formControlName="rStabName">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">E Module:</span>
                                    <input type="number" step="0.01" formControlName="eModule" [(ngModel)]="editedMaterial.eModule">
                                    <span>&emsp;[N/m<sup>2</sup>]</span>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">G Module:</span>
                                    <input type="number" step="0.01" formControlName="gModule" [(ngModel)]="editedMaterial.gModule">
                                    <span>&emsp;[N/m<sup>2</sup>]</span>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Fu:</span>
                                    <input type="number" step="0.01" formControlName="fu" [(ngModel)]="editedMaterial.fu">
                                    <span>&emsp;[N/m<sup>2</sup>]</span>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Ni:</span>
                                    <input type="number" step="0.01" formControlName="ni" [(ngModel)]="editedMaterial.ni">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Density:</span>
                                    <input type="number" step="0.01" formControlName="density" [(ngModel)]="editedMaterial.density">
                                    <span>&emsp;[N/m<sup>3</sup>]</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="materialForm.invalid" (click)="saveNewMaterial()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="materialForm">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedMaterial.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedMaterial.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">R Stab Name:</span>
                                    <input type="text" [(ngModel)]="editedMaterial.rStabName" formControlName="rStabName">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">E Module:</span>
                                    <input type="number" step="0.0001" formControlName="eModule" [(ngModel)]="editedMaterial.eModule">
                                    <span>&emsp;[N/m<sup>2</sup>]</span>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">G Module:</span>
                                    <input type="number" step="0.0001" formControlName="gModule" [(ngModel)]="editedMaterial.gModule">
                                    <span>&emsp;[N/m<sup>2</sup>]</span>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Fu:</span>
                                    <input type="number" step="0.0001" formControlName="fu" [(ngModel)]="editedMaterial.fu">
                                    <span>&emsp;[N/m<sup>2</sup>]</span>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Ni:</span>
                                    <input type="number" step="0.0001" formControlName="ni" [(ngModel)]="editedMaterial.ni">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Density:</span>
                                    <input type="number" step="0.0001" formControlName="density" [(ngModel)]="editedMaterial.density">
                                    <span>&emsp;[N/m<sup>3</sup>]</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="materialForm.invalid" (click)="editMaterial()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this material?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteMaterial(editedMaterial)">Delete</button>
            </div>
        </div>
    </div>
</div>

<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addMaterialModal" (click)="prepareCreate()">Create</button>
<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let material of materialsGridData, let row_no = index">
        <td>{{material.name}}</td>
        <td>{{material.description}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(material, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(material, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class MaterialsGridComponent implements OnInit {
  isMaterialsHidden = true;
  materialsGridData: MaterialModel[];
  editedMaterial = new MaterialModel();
  materialForm: FormGroup;
  rowNumber: number;
  headers: string[] = ['Name', 'Description', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteMaterialSubject.subscribe( (value) => {
      this.materialsGridData = this.materialsGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllMaterials().subscribe((response) => {
      this.materialsGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isMaterialsHidden = !this.isMaterialsHidden;
  }

  saveNewMaterial() {
    this.mainPageService.addNewMaterialIntoDb(JSON.stringify(this.editedMaterial)).subscribe((response) => {
      this.editedMaterial._id = response;
      this.materialsGridData.push(this.editedMaterial);
      this.editedMaterial = new MaterialModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedMaterial = {
      ...element,
    };
    this.rowNumber = row;
    this.createForm();
  }

  editMaterial() {
    console.log(this.materialsGridData[this.rowNumber]);
    Object.assign(this.materialsGridData[this.rowNumber], this.editedMaterial);
    this.mainPageService.updateMaterialInDb(JSON.stringify(this.editedMaterial)).subscribe((response) => {});
  }

  deleteMaterial(element) {
    this.mainPageService.removeMaterial(element._id).subscribe((res) => {}, (error: any) => {});
    this.mainPageService.deleteMaterialSubject.next(element._id);
  }

  prepareCreate() {
    this.editedMaterial = new MaterialModel();
    this.createForm();
  }

  private createForm() {
    this.materialForm = new FormGroup({
      name: new FormControl(this.editedMaterial.name, Validators.required),
    description: new FormControl(this.editedMaterial.description),
    rStabName: new FormControl(this.editedMaterial.rStabName),
    eModule: new FormControl(this.editedMaterial.eModule, Validators.pattern('^\\d+(?:\\.\\d{1,10})?$')),
    gModule: new FormControl(this.editedMaterial.gModule, Validators.pattern('^\\d+(?:\\.\\d{1,10})?$')),
    fu: new FormControl(this.editedMaterial.fu, Validators.pattern('^\\d+(?:\\.\\d{1,10})?$')),
    ni: new FormControl(this.editedMaterial.ni, Validators.pattern('^\\d+(?:\\.\\d{1,10})?$')),
    density: new FormControl(this.editedMaterial.density, Validators.pattern('^\\d+(?:\\.\\d{1,10})?$')),
    });
  }

}
